import React from 'react'

const Hero = () => {
  return (
   <>
        <section className="hero d-flex align-items-end pos-rel pt-80">
            <div className="container">
                <div className="hero__content-inner pos-rel">
                    <div className="row align-items-end">
                        <div className="hero__content text-center mb-80">
                            <h1 className="wow fadeInUp" data-wow-delay="1300ms" data-wow-duration="3.7s">Crafting Digital Brilliance: <img src="assets/img/hero/h_01.png"  alt=""/> Empowering Brands, <img src="assets/img/hero/h_02.png" alt=""/> Building Futures</h1>
                        </div>
                        <div className="hero__img text-center">
                            <img className="wow fadeInUp"  data-wow-delay="200ms" data-wow-duration=".7s" src="assets/img/hero/s7.webp" style={{opacity: "0.95", border: "4px solid #414146", borderBottom: "0", borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}} alt=""/>
                            <div className="hero__img-2">
                                {/* <img className="wow fadeInUp" data-wow-delay="300ms" data-wow-duration=".7s" src="assets/img/hero/img_02.png" alt=""/>
                                <img className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration=".7s" src="assets/img/hero/img_03.png" alt=""/> */}
                            </div>
                            <div className="hero__shape-icon">
                                <div className="shape shape--1">
                                    <div data-parallax='{"x":-50,"y":-80}'>
                                        <img className="wow fadeInLeft" data-wow-delay="450ms" data-wow-duration=".7s" src="assets/img/shape/h_shape.png" alt=""/>
                                    </div>
                                </div>  
                                <div className="shape shape--2">
                                    <div data-parallax='{"x":50,"y":-80}'>
                                        <img className="wow fadeInRight" data-wow-delay="480ms" data-wow-duration=".7s" src="assets/img/shape/h_shape2.png" alt=""/>
                                    </div>
                                </div>  
                            </div>
                        </div>
                        <div className="hero__shape">
                            <img className="wow fadeIn" data-wow-delay="400ms" data-wow-duration=".7s" src="assets/img/hero/shape.png" alt=""/>
                        </div>
                        <div className="hero__noise">
                            <img className="wow fadeIn" data-wow-delay="400ms" data-wow-duration=".7s" src="assets/img/hero/noise.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   </>
  )
}

export default Hero
